export const billingQueryKeys = {
  qrModal: ['qrModal'],
  qrValidatedModal: ['qrValidatedModal'],
  orderStatus: ['orderStatus'],
  orderId: ['orderId'],
  availablePayments: ['availablePayments'],
  activeCart: ['activeCart']
};
